export class IDailyBalance {
    slpCode: String;
      Motivo: String;
      Monto: number;
      FechaIni:  Date;
}